export default function customers(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT_CUSTOMER':
            return {
                ...state,
                customer: action.customer,
            }
        default:
            return state;
    }
}